import { z } from 'zod';

export const medicationCreateSchema = z.object({
  name: z.string().min(1).max(60),
  unit: z.string().min(1).max(12),
  default_dose: z.number().positive().nullable().optional(),
  min_interval_minutes: z.number().int().min(0).max(24 * 60).nullable().optional(),
  color: z.string().regex(/^#[0-9a-fA-F]{6}$/).nullable().optional(),
  notes: z.string().max(2000).nullable().optional(),
});

export const medicationPatchSchema = medicationCreateSchema.partial().extend({
  archived_at: z.number().int().nullable().optional(),
});

export const medicationEventCreateSchema = z.object({
  medication_id: z.string(),
  occurred_at: z.number().int().optional(),
  dose: z.number().positive(),
  unit: z.string().min(1).max(12),
  notes: z.string().max(2000).nullable().optional(),
});

export const medicationEventPatchSchema = medicationEventCreateSchema.partial();

export type MedicationCreateInput = z.infer<typeof medicationCreateSchema>;
export type MedicationPatchInput = z.infer<typeof medicationPatchSchema>;
export type MedicationEventCreateInput = z.infer<typeof medicationEventCreateSchema>;
export type MedicationEventPatchInput = z.infer<typeof medicationEventPatchSchema>;
